type Listener = (pct: number | null) => void;
type CompleteListener = (realId: string) => void;

const values = new Map<string, number>();
const listeners = new Map<string, Set<Listener>>();
const completed = new Map<string, string>();
const completeListeners = new Map<string, Set<CompleteListener>>();

export function emitProgress(tempId: string, pct: number): void {
  values.set(tempId, pct);
  listeners.get(tempId)?.forEach((l) => l(pct));
}

export function getProgress(tempId: string): number | null {
  return values.get(tempId) ?? null;
}

export function subscribeProgress(tempId: string, listener: Listener): () => void {
  let set = listeners.get(tempId);
  if (!set) {
    set = new Set();
    listeners.set(tempId, set);
  }
  set.add(listener);
  return () => {
    set!.delete(listener);
    if (set!.size === 0) listeners.delete(tempId);
  };
}

export function clearProgress(tempId: string): void {
  values.delete(tempId);
  listeners.get(tempId)?.forEach((l) => l(null));
}

export function emitComplete(tempId: string, realId: string): void {
  completed.set(tempId, realId);
  completeListeners.get(tempId)?.forEach((l) => l(realId));
}

export function getCompleted(tempId: string): string | null {
  return completed.get(tempId) ?? null;
}

export function subscribeComplete(tempId: string, listener: CompleteListener): () => void {
  let set = completeListeners.get(tempId);
  if (!set) {
    set = new Set();
    completeListeners.set(tempId, set);
  }
  set.add(listener);
  return () => {
    set!.delete(listener);
    if (set!.size === 0) completeListeners.delete(tempId);
  };
}

export function clearComplete(tempId: string): void {
  completed.delete(tempId);
  completeListeners.delete(tempId);
}
